"use client";

import * as React from "react";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@repo/ui";
import {
  type AppLocale,
  useLocale,
  useMessages,
  useSetLocale,
} from "@/locales";

/**
 * Global language switcher. Persists preference; keeps route/auth/tenant context.
 */
export function LanguageSwitcher({ className }: { className?: string }) {
  const locale = useLocale();
  const setLocale = useSetLocale();
  const m = useMessages();

  return (
    <Select
      value={locale}
      onValueChange={(value) => {
        if (value === "en" || value === "zh-CN") {
          setLocale(value as AppLocale);
        }
      }}
    >
      <SelectTrigger
        size="compact"
        className={className ?? "w-[9.5rem]"}
        aria-label={m.language.label}
      >
        <SelectValue placeholder={m.language.label} />
      </SelectTrigger>
      <SelectContent>
        <SelectItem value="en">{m.language.en}</SelectItem>
        <SelectItem value="zh-CN">{m.language.zhCN}</SelectItem>
      </SelectContent>
    </Select>
  );
}
